/**
 *=================================== AUTHOR : MUSKAN KHAN===========================
 * ===================================DATE : 10 OCT 2024========================
 */
import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import Confirm from "../Confirm";
import { useParams, useNavigate, Link } from "react-router-dom";
import SparkApi from "../../api/SparkApi";
import RackCreate from "./RackCreate";
import Barcode from "react-barcode";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import InfoPill from "../InfoPill";
import { ShimmerTable } from "react-shimmer-effects";
import { toast, ToastContainer } from 'react-toastify';
import { usePermission } from "../context/PermissionContext";

const RackView = () => {
  const [body, setBody] = useState([]);
  const [rackRec, setRackRec] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [createShowModal, setCreateShowModal] = useState(false);
  const [productdata, setProductRack] = useState([]);
  const { permissionData , userInfo } = usePermission();
  const can_edit = permissionData?.Rack?.can_edit;
  const can_delete = permissionData?.Rack?.can_delete;

  const navigate = useNavigate();
  const { id: paramId } = useParams();

  useEffect(() => {
    fetchRack();
  }, []);

  useEffect(() => {
    fetchProductRack();
  }, []);

  const fetchRack = async () => {
    try {
      const result = await SparkApi.fetchRackById(paramId);
      if (result.success) {
        setRackRec(result.data);
      } else {
        setRackRec({});
      }
    } catch (error) {
      console.error("Error fetching rack:", error);
    }
  };

  const fetchProductRack = async () => {
    try {
      const result = await SparkApi.fetchProductRack(paramId);
      if (result.success) {
        setProductRack(result.records);
        setBody(result.records);
      } else {
        setProductRack([]);
      }
    } catch (error) {
      console.error("Error fetching product rack:", error);
    }
  };

  const deleteRack = async () => {
    try {
      const result = await SparkApi.deleteRack(rackRec.id);
      if (result.success) {
        toast.success("Rack deleted successfully");
        setTimeout(() => {
          navigate(`/racks`);
        }, 2000);
      } else {
        toast.error("Failed to delete the rack");
      }
    } catch (error) {
      toast.error("An error occurred while deleting the rack");
    }
  };

  const editRack = () => {
    setCreateShowModal(true);
  };

  const columns = [
    {
      title: "Barcode",
      prop: "barcode",
      cell: (row) =>
        row.barcode ? (
          <Barcode value={row.barcode} width={1} height={30} displayValue={true} />
        ) : (
          <span>No Barcode</span>
        ),
      isFilterable: true
    },
    { title: "Products", prop: "name", isFilterable: true },
    { title: "Quantity", prop: "quantity", isFilterable: true },
  ];

  return (
    <div>
      {rackRec && (
        <Container>
            <ToastContainer position="top-center" autoClose={1500} theme="light" />

            {createShowModal && (
              <RackCreate
                show={createShowModal}
                onHide={() => setCreateShowModal(false)}
                rackRec={rackRec}
                fetchRack={fetchRack}
              />
            )}

            {modalShow && (
              <Confirm
                show={modalShow}
                onHide={() => setModalShow(false)}
                deleteRack={deleteRack}
                title="Confirm delete?"
                message="You are going to delete the record. Are you sure?"
                table="rack"
              />
            )}

            <Row className="border-bottom mb-3">
              <Col lg={2} className="mb-2 pt-2">
                <Link className="nav-link" to="/racks">
                  Home <i className="fa-solid fa-chevron-right"></i>{" "}
                  <div style={{ color: "#23468c", display: "inline" }}>Rack</div>
                </Link>
              </Col>
            </Row>

            <Row className="view-form">
              <Col lg={2}></Col>
              <Col lg={8}>
                <Row className="view-form-header align-items-center">
                  <Col lg={8} xs={8}>
                    Rack<h5>{rackRec ? rackRec.name : ""}</h5>
                  </Col>
                  <Col lg={4} xs={4} className="d-flex justify-content-end">
                    {(userInfo?.userrole === "ADMIN" || can_edit) && 
                      (<Button className="btn-sm mx-2" onClick={editRack}>
                        <i className="fa-regular fa-pen-to-square"></i>
                      </Button>
                    )}
                    {(userInfo?.userrole === "ADMIN" || can_delete) && (
                      <Button className="btn-sm" variant="danger" onClick={() => setModalShow(true)}>Delete</Button>
                    )}
                  </Col>
                </Row>

                <Row className="py-3 ibs-edit-form">
                  <Col lg={6}>
                    <label>Name</label>
                    <span>{rackRec.name || <br />}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Warehouse name</label>
                    <span>{rackRec.warehouse_name || <br />}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Status</label>
                    <span>{rackRec.status === 'Active' ? rackRec.status : 'InActive' || <br />}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Description</label>
                    <span>{rackRec.description || <br />}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Barcode</label>
                    {rackRec.barcode ? (
                      <Barcode value={rackRec.barcode} width={2} height={60} />
                    ) : (
                      <br />
                    )}
                  </Col>
                </Row>
              </Col>
              <Col lg={2}></Col>
            </Row>
          <div>
            <Row>
              <Col lg={12}>
                {body ? (
                  <DatatableWrapper
                    body={body}
                    headers={columns}
                    paginationOptionsProps={{
                      initialState: {
                        rowsPerPage: 10,
                        options: [5, 10, 15, 20],
                      },
                    }}
                  >
                    <Row className="mb-4">
                      <Col xs={12} lg={4} className="d-flex flex-col justify-content-end align-items-end">
                        <Filter />
                      </Col>
                      <Col xs={12} sm={6} lg={4} className="d-flex flex-col justify-content-start align-items-start">
                        <PaginationOptions labels={{ beforeSelect: " " }} />
                        <div className="mt-2">
                          <InfoPill left="Total Products" right={body?.length} />
                        </div>
                      </Col>
                    </Row>
                    <Table striped className="data-table" responsive="sm">
                      <TableHeader />
                      <TableBody />
                    </Table>
                    <Pagination />
                  </DatatableWrapper>
                ) : (
                  <ShimmerTable row={10} col={8} />
                )}
              </Col>

            </Row>
          </div>
        </Container>
      )}
    </div>
  );
};

export default RackView;
